import {BlogArticleTile} from "./BlogArticleTile";

export default {
    title: 'Blog/Blog Article Tile',
    component: BlogArticleTile,
    parameters: {
        layout: 'centered',
    },
    tags: ['autodocs']
};

export const Default = {
    args: {
        props: {
            article: {
                title: "Test",
                image: "https://placehold.co/400x400/jpg"
            }
        }
    },
};




